import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { SDD_FEATURE_GATE_KEYS } from '@codemerlin/shared';

type EffectiveGateRow = { gate_key: string; effective_allowed: boolean };

type EffectiveGatesResponse = {
  organization_id: string;
  gates: EffectiveGateRow[];
};

/** DC-388 — parent gate for standards catalog, applicability tab, and routing read models. */
export function useGovernanceStandardsWorkflowsGate(organizationId: string | undefined) {
  return useQuery({
    queryKey: [
      'sdd-feature-gates-effective',
      organizationId,
      SDD_FEATURE_GATE_KEYS.GOVERNANCE_STANDARDS_WORKFLOWS_ENABLED,
    ],
    queryFn: async () => {
      if (!organizationId) return false;
      const data = await api.get<EffectiveGatesResponse>(
        `organizations/${organizationId}/feature-gates/effective`
      );
      return data.gates.some(
        (g) =>
          g.gate_key === SDD_FEATURE_GATE_KEYS.GOVERNANCE_STANDARDS_WORKFLOWS_ENABLED &&
          g.effective_allowed === true
      );
    },
    enabled: !!organizationId,
    staleTime: 30_000,
  });
}
